import React from 'react';

const TableTennis = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 14 14'
            className={className}
        >
            <g id='Table_Tennis' data-name='Table Tennis' transform='translate(-56.306 -467.447)'>
                <path
                    id='Path_3120'
                    data-name='Path 3120'
                    d='M69.979,474.331a7.252,7.252,0,0,1-1.286,3.029,5.8,5.8,0,0,1-2.2,1.745.54.54,0,0,1-.706-.13q-3.642-3.689-7.32-7.342c-.355-.351-.163-.618-.025-.911A6.112,6.112,0,0,1,69.876,472.5a2.223,2.223,0,0,0,.1.3Z'
                    transform='translate(0.327)'
                />
                <path
                    id='Path_3121'
                    data-name='Path 3121'
                    d='M57.545,480.7c-1.417-.69-1.678-1.856-.475-2.861A4.291,4.291,0,0,0,58.5,472.91a6.4,6.4,0,0,1-.135-.975l6.714,6.748c-.656-.1-1.347-.18-2.026-.323a3.212,3.212,0,0,0-3.212.988c-.468.492-1.021.9-1.535,1.351Z'
                    transform='translate(0 0.748)'
                />
            </g>
        </svg>
    );
};

export default TableTennis;
